import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import { loading } from '@/shared/utils/UIHelper'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'

export default {
  name: 'searchmiscellaneousreimbursement',
  mixins: [ActionsForm, ExpenseMixin],
  components: {AutocompleteZ},
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        lote: null,
        obraid: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        coordenadorId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        situacao: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        empresa: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      DataFimFiltro: null,
      DataInicioFiltro: null
    }
  },
  mounted () {
    this.GetStatusDespesa()
  },
  methods: {
    onClear () {
      this.$refs.favorecidoTypeahead.clear()
      this.form.situacao.value = null
      this.form.lote = null
      this.$refs.responsavelTypeahead.clear()
      this.$refs.obraRHTypeahead.clear()
      if (this.$refs.empresaTypeahead) {
        this.$refs.empresaTypeahead.clear()
      }
    },
    onSearchFuncionarioDespesasDiversos (value) {
      loading.push()
      MiscellaneousExpensesRepository.OnSearchFuncionarioDespesasDiversos(value)
        .then((response) => {
          this.$refs.funcionarioTypeahead.data = response.data
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFuncionarioDespesasDiversos (value) {
      loading.push()
      MiscellaneousExpensesRepository.OnChangeCodeFuncionarioDespesasDiversos(value)
        .then((response) => {
          this.$refs.funcionarioTypeahead.setValue(response.data)
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    Search () {
      let data = {
        Funcionarioid: this.form.funcionarioId.value,
        StatusDespesa: this.form.situacao.value,
        CoordenadorId: this.form.coordenadorId.value,
        EmpresaId: this.form.empresa.value,
        ObraId: this.form.obraid.value,
        Lote: this.form.lote
      }
      this.$emit('search', data)
    },
    GetStatusDespesa () {
      MiscellaneousExpensesRepository.GetStatusDespesasDiversos()
        .then((Response) => {
          this.dataStatusDespesa.push(Response.data[1], Response.data[2], Response.data[3], Response.data[9])
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/searchmiscellaneousreimbursement/searchmiscellaneousreimbursement.js